import { createSlice } from '@reduxjs/toolkit';
import { getEventsListThunk } from './Events.thunk';
import { EventState } from './Events.type';
import { RootState } from '../../store';

const initialState: EventState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const eventsSlice = createSlice<EventState, any>({
  name: 'events',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getEventsListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getEventsListThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getEventsListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const getEventsList = (state: RootState) =>
  state.events.items;

export default eventsSlice.reducer;
